import { Theme } from "../component/navigation/ThemeDropdown";

export default function DashboardIcon({
    isSelected,
    theme,
}: {
    isSelected: boolean;
    theme: Theme;
}) {
    return (
        <div style={{ display: "inline-block", cursor: "pointer" }}>
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    transition: "fill 0.3s ease",
                }}
            >
                {/* Outer Circle */}
                <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Main Rectangle */}
                <path
                    d="M18.6504 6.48547H5.34656C5.10203 6.48547 4.90381 6.6837 4.90381 6.92822V17.0717C4.90381 17.3163 5.10203 17.5145 5.34656 17.5145H18.6504C18.8949 17.5145 19.0931 17.3163 19.0931 17.0717V6.92822C19.0931 6.6837 18.8949 6.48547 18.6504 6.48547Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#FFFFFF"
                                : "#606161"
                            : isSelected
                              ? "#2D3748"
                              : "#2D3748"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Bottom Rectangle */}
                <path
                    d="M17.1481 15.1481H6.92825C6.71745 15.1481 6.54657 15.319 6.54657 15.5298V15.6885C6.54657 15.8993 6.71745 16.0702 6.92825 16.0702H17.1481C17.3589 16.0702 17.5298 15.8993 17.5298 15.6885V15.5298C17.5298 15.319 17.3589 15.1481 17.1481 15.1481Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Left Side Line */}
                <path
                    d="M6.54962 8.44888L6.54962 15.6855C6.54962 15.8963 6.72051 16.0672 6.9313 16.0672H7.09008C7.30088 16.0672 7.47176 15.8963 7.47176 15.6855V8.44888C7.47176 8.23808 7.30088 8.0672 7.09008 8.0672H6.9313C6.72051 8.0672 6.54962 8.23808 6.54962 8.44888Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Middle Tick */}
                <path
                    d="M9.08702 13.887C8.95267 13.887 8.81527 13.8351 8.71145 13.7313C8.50382 13.5237 8.50382 13.1878 8.71145 12.9832L11.3618 10.3328C11.4626 10.2321 11.5969 10.1771 11.7374 10.1771C11.8779 10.1771 12.0122 10.2321 12.113 10.3328L13.6275 11.8474L14.9802 10.4947C15.1878 10.287 15.5237 10.287 15.7282 10.4947C15.9359 10.7023 15.9359 11.0382 15.7282 11.2428L14 12.971C13.8015 13.1695 13.4504 13.1695 13.2519 12.971L11.7374 11.4565L9.4626 13.7313C9.35878 13.8351 9.22443 13.887 9.08702 13.887Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
                {/* Right Top Arrow */}
                <path
                    d="M16.9343 9.0901L14.2046 9.82292C14.1069 9.85041 14.0733 9.97254 14.1466 10.0428L16.1466 12.0428C16.2168 12.113 16.3389 12.0825 16.3664 11.9848L17.0992 9.25499C17.1267 9.15728 17.0351 9.06873 16.9374 9.09315L16.9343 9.0901Z"
                    fill={
                        theme === "light"
                            ? isSelected
                                ? "#C6D92D"
                                : "#D8D8D8"
                            : isSelected
                              ? "#C6D92D"
                              : "#7A8690"
                    }
                    style={{
                        transition: "fill 0.3s ease",
                    }}
                />
            </svg>
        </div>
    );
}
